<template>
    <el-dialog :title="showTitle" :visible.sync="showFlag" :close-on-click-modal="false">
        <el-form
            :inline="true"
            :model="formData"
            class="demo-ruleForm"
            label-width="100px"
            :rules="formRules"
            ref="formData"
            :size="GLOBAL.config.systemSize"
            element-loading-text="数据处理中...请稍等..."
            v-loading="loading">
            <el-form-item label="栏目名称：" prop="title" style="margin-top: 20px">
                <el-input v-model="formData.title" placeholder="栏目种类" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="内容：" prop="nr" style="margin-top: 20px">
                <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" v-model="formData.nr" placeholder="内容" maxlength="100"></el-input>
            </el-form-item>
        </el-form>
        <el-row class="margin-top-20">
            <el-button @click="closeDialog" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>
            <el-button type="primary" @click="saveOrUpdateForm('formData')" style="margin: 0 20px;"
                        :size="GLOBAL.config.systemSize">保存
            </el-button>
        </el-row>
    </el-dialog>
</template>

<script>
import cascader from '../../components/Cascader'
export default {
    name: 'NoticeEditDialog',

    components: {
        cascader
    },

    props: {
      refresh: {
        type: Function
      },
    },
    data() {
        return{
            showTitle: '',
            showFlag: false,
            formData: {
                uuid: '',
                nr: '',
                title: ''
            },
            loading: false,
            sfqsOptions: [
                {value: '0', label: '签收'},
                {value: '1', label: '无需签收'}
            ],
            formRules: {
                title: [
                    {required: true, message: '栏目种类不能为空', trigger: 'change'}
                ],
                nr: [
                    {required: true, message: '内容不能为空', trigger: 'change'}
                ],
            },
            //所属区域
            setProps: {
                multiple: false, // 单选
                checkStrictly: true, // 父节点取消选中关联
                value: 'code',
                label: 'name',
                children: 'children',
                leaf: 'leaf'
            }
        }
    },

    methods: {
        open(type, rowData) {
            let _this = this;
            let title = '';
            _this.type = type;
            if (type == 'edit') {
                title = '通知公告栏目配置编辑';
                _this.formData.uuid = rowData.uuid;
                _this.formData.nr = rowData.nr;
                _this.formData.title = rowData.title;
                _this.formData.ssqhdm = rowData.ssqhdm;
                // _this.formData.sfqs = rowData.sfqs;
                // _this.formData.sfyd = rowData.sfyd;
            } else if (type == 'add') {
                title = '通知公告栏目配置新增';
                _this.formData = {
                    uuid: '',
                    nr: '',
                    title: ''
                }
            }
            setTimeout(function () {
              _this.$refs.myArea.init(_this.formData.ssqhdm)
            }, 100)
            _this.showFlag = true;
            _this.showTitle = title;
        },
        saveOrUpdateForm(formName) {
            let _this = this;
            let param = {};
            param = _this.formData;
            param.cjdwdm = JSON.parse(unescape(localStorage.getItem('gcUserInfo'))).cjdwdm;
            param.baseService = 'TGcTztgServiceImpl';
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let method = "";
                    if (_this.formData.uuid) {
                        method = _this.GLOBAL.config.handleType.updateAll;
                    } else {
                        method = _this.GLOBAL.config.handleType.add;
                    }
                    _this.FUNCTIONS.systemFunction.interactiveData(
                        _this,
                        _this.GLOBAL.config.businessFlag.zxUser,
                        method,
                        param,
                        null,
                        resultData => {
                            _this.loading = false
                            if (resultData) {
                                _this.$message.success('保存成功～')
                                _this.showFlag = false;
                                _this.$props.refresh && _this.$props.refresh('init')
                            } else {
                                _this.$message.warning('获取列表数据失败～')
                            }
                        },
                        () => {
                            _this.loading = false
                        }
                    )
                } else {
                    return false;
                }
            });
        },
        closeDialog() {
            this.$refs['formData'].resetFields();
            this.showFlag = false;
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/notice/NoticeEditDialog.vue